export const it_login= {
    username: 'Email',
    password: 'Password',
    letto: 'Ho letto e accettato le ',
    condizioni: 'condizioni di vendita',
    dimenticato: 'Hai dimenticato la password?',
    login: 'Login',
    utilizza: 'Utilizza le credenziali di ',
};